import browser from './browser'
import modules from './modules'

class JsApi {
    constructor() {
        this.browser = browser
        Object.assign(this, modules)
    }
}
window.JsApi = new JsApi()
export default JsApi
